import * as React from 'react';

import * as styles from './button.scss';
import * as _ from 'lodash';

export const BUTTON_THEMES = {
	primary: 'BTN_PRIMARY',
	secondary: 'BTN_SECONDARY',
	tertiary: 'BTN_TERTIARY'
};

interface Props
	extends React.DetailedHTMLProps<
	React.ButtonHTMLAttributes<HTMLButtonElement>,
	HTMLButtonElement
	> {
	busy?: boolean;
	clickHandler?: (e: any) => void;
	theme?: any;
	className?: any;
	buttonFullWidth?: boolean;
	onMouseDown?: any;
}

const Button: React.SFC<Props> = props => {
	const themeClass = () => {
		switch (props.theme) {
			case BUTTON_THEMES.tertiary:
				return ' ' + styles.btnTertiary;
			case BUTTON_THEMES.secondary:
				return ' ' + styles.btnSecondary;
			default:
				return ' ' + styles.btnPrimary;
		}
	};

	// const enrichedOnClickEvent = () => {
	// 	props.clickHandler(props.name)
	// };

	// const handleClick = (event?: React.MouseEvent<HTMLButtonElement>) => {
	const handleClick = () => {
		if (props.clickHandler) {
			props.clickHandler(props.name);
		}
	};
	return (
		<button
			type={props.type}
			className={
				styles.btnDefault +
				' ' +
				themeClass() +
				' ' +
				props.className +
				' ' +
				(props.buttonFullWidth ? styles.buttonFullWidth : '') + 
				' ' +
				(props.disabled ? styles.disabled : '')
			}
			disabled={props.disabled}
			onClick={_.throttle(handleClick, 1000, {
				leading: true
			})}
		>
			{!props.busy ? (
				<span className={styles.buttonLabel}> {props.children} </span>
			) : (
					''
				)}
			{props.busy ? (
				<div className={styles.busy}>
					<span className={styles.busyInner} />
					<span className={styles.busyInner} />
					<span className={styles.busyInner} />
				</div>
			) : (
					''
				)}
		</button>
	);
};

Button.defaultProps = {
	type: 'button'
};

export default Button;
